// extracted by mini-css-extract-plugin
module.exports = {"Panel":"Panel--1OSOd"};